export default "__VITE_ASSET__IYugD6oYzZUy9Xg0sDhosQ__"